import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    IconButton, Typography, useTheme
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useStyles } from './AboutStyles'
import { ReactComponent as ImageTopLogin } from '../../assets/login.svg'
import { GenericContainer, GenericContainerCenter } from '../../components'
import packageJson from "../../../package.json";

export default function AboutComponent(props) {
    const localStyles = useStyles()
    // const navigate = useNavigate()

    // let handleBack = () => {
    //     // history.goBack()
    // }

    return (<GenericContainer>
        <GenericContainerCenter sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }} >
        {/* <IconButton
                        aria-label="back"
                        className={localStyles.backButton}
                        onClick={handleBack}>
                        <ArrowBackIcon />
                    </IconButton> */}
        {/* <ImageTopLogin className={localStyles.imageTop}/> */}
        <Typography variant="h6" sx={{marginTop:5}} >
            Onboarding PWA
        </Typography>
        <Typography variant="subtitle" sx={{marginTop:5}}>
            Versión: {packageJson.version}
        </Typography>
       {/*  <Typography variant="caption" sx={{marginTop:5}} align='justify' >
            Para reportar un problema con la aplicación <b>Digital Onboarding</b> llamanos al: <b>(800)DS 10 000</b> o escribenos a: <b>info@docsolutions.com</b>
        </Typography> */}
        </GenericContainerCenter>
    </GenericContainer>)
}